import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { CompanyGuard } from '@/components/company/CompanyGuard';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg text-content-secondary">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnTo = location.pathname + location.search;
    const loginUrl = returnTo !== '/dashboard'
      ? `/login?redirect=${encodeURIComponent(returnTo)}`
      : '/login';
    return <Navigate to={loginUrl} replace />;
  }

  return (
    <CompanyGuard>
      <Outlet />
    </CompanyGuard>
  );
}
